// @flow
import type { StatelessFunctionalComponent } from 'react';
import styled from 'styled-components';

const QuotersListWrapper: StatelessFunctionalComponent<*> = styled.div`
  padding: 20px 10px !important;
  font-size: 1.5em !important;
  a { 
    color: inherit;
    text-decoration: none;
  } 

  .Card-box {
    &:hover {
      background-color: rgba(0, 0, 0, 0.02);
    }
    
    &:active {
      box-shadow: 0 0px 2px 0 rgba(50,50,50,0.12);
    }
  }

  .QuotersList {
    &-container {
      display: grid;
      padding: 35px 75px 0px 75px;
      grid-template-columns: repeat(6, 1fr);
      grid-gap: 0px 30px;
    }

    @media (min-width: 901px){
      &-item {
        grid-column: span 2;
        &:last-child:nth-child(3n - 1) { grid-column-end: -2; }
        &:nth-last-child(2):nth-child(3n + 1) { grid-column-end: 4; }
        &:last-child:nth-child(3n - 2) { grid-column-end: 5; }
      }
    }

    @media (max-width: 900px){
      &-container {
        grid-template-columns: repeat(4, 1fr);
      }

      &-item {
        grid-column: span 2;
        &:nth-last-child(1):nth-child(odd) { grid-column: 2 / span 2; }
      }
    }

    @media (max-width: 650px){
      &-container {
        grid-template-columns: repeat(3, 1fr);
      }

      &-item {
        grid-column: span 3;
        &:nth-last-child(1):nth-child(odd) { grid-column: 1 / span 3; }
      }
    }

    &-link {
      height: 75px;
      display: grid;
      grid-template-columns: 1fr 2fr;

      &-img {
        height: 30px;
      }

      &-content {
        margin: auto;
        text-align: center;
        justify-self: center;
        padding: 15px;
        font-size: 1.2em !important;
        color: var(--text-color-2);
      }
    }
  }

`;

export default QuotersListWrapper;
